var map = {
	"./Baguette.jpg": "xId+",
	"./Belts1.jpg": "lWah",
	"./FASHION_ACC.jpg": "4sqE",
	"./FASHION_JEWEL.jpg": "43/z",
	"./Fashion Accessories.jpg": "mhPC",
	"./Fashion Jewelry.jpg": "n8Sa",
	"./Fur.jpg": "gZ2v",
	"./JsecureColorTif.jpg": "2oNR",
	"./M_BAGS.jpg": "Zzr3",
	"./M_MINI_BAGS.jpg": "LPza",
	"./M_RTW.jpg": "oaxU",
	"./M_SHOES.jpg": "sX1M",
	"./M_SLG.jpg": "09Tg",
	"./Man Bags.jpg": "KFEI",
	"./Man Mini Bags.jpg": "jVvs",
	"./Man Peekaboo.jpg": "tC4i",
	"./Man RTW.jpg": "iXN8",
	"./Man SLG.jpg": "3kkl",
	"./Man Shoes.jpg": "OZav",
	"./Mini Bags.jpg": "06mX",
	"./Peekaboo Baguette.jpg": "Dlut",
	"./SAMPLE.jpg": "gM79",
	"./Sunglasses1.jpg": "At/9",
	"./Textiles1.jpg": "tD8M",
	"./VbV_TC_2CRev_sm.jpg": "zM/j",
	"./W_BAGS.jpg": "Aq/L",
	"./W_FUR.jpg": "24rH",
	"./W_MINI_BAGS.jpg": "hUrP",
	"./W_RTW.jpg": "n3Ih",
	"./W_SHOES.jpg": "vKAS",
	"./W_SLG.jpg": "7Hau",
	"./Watches1.jpg": "+WNn",
	"./Woman Bags.jpg": "bWvW",
	"./Woman Peekaboo.jpg": "v8Aj",
	"./Woman RTW.jpg": "O6QM",
	"./Woman SLG.jpg": "eKID",
	"./Woman Shoes.jpg": "AVhc",
	"./Woman minibags.jpg": "1SJo",
	"./app-bg.png": "2Otq",
	"./app_banner.png": "p2S8",
	"./bagutte.jpg": "tMWS",
	"./bg.png": "C34Q",
	"./c1.png": "mSHj",
	"./c2.png": "mt4l",
	"./c3.png": "Il40",
	"./cart-no.png": "VmlR",
	"./category-select-bg.png": "wHvD",
	"./category-select-logo.png": "i/Hu",
	"./count-down-bg-big-size.jpg": "t2l3",
	"./count-down-bg.jpg": "0ih6",
	"./countdown-bg-en.png": "OjvC",
	"./countdown-bg-mb-en.png": "BA83",
	"./countdown-bg-mb.png": "tnJW",
	"./countdown-bg.png": "LuaY",
	"./cover/20210918/bags.jpg": "h75U",
	"./cover/20210918/baguetteman.jpg": "GUl2",
	"./cover/20210918/baguettewoman.jpg": "J71z",
	"./cover/20210918/fur.jpg": "em5F",
	"./cover/20210918/minibagsman.jpg": "a5jL",
	"./cover/20210918/minibagswoman.jpg": "zFej",
	"./cover/20210918/peekabooman.jpg": "mmL4",
	"./cover/20210918/peekaboowoman.jpg": "hTHc",
	"./cover/20210918/rtwman.jpg": "wxvC",
	"./cover/20210918/rtwwoman.jpg": "tA5U",
	"./cover/20210918/shoesman.jpg": "0axB",
	"./cover/20210918/shoeswoman.jpg": "TwAe",
	"./cover/20210918/slgman.jpg": "aJVT",
	"./cover/20210918/slgwoman.jpg": "I1pw",
	"./cover/20210918/watches.jpg": "zzMJ",
	"./cover/Man RTW.jpg": "zL9e",
	"./cover/Man Shoes.jpg": "I0GG",
	"./cover/Woman Shoes.jpg": "S82i",
	"./cover/bags.jpg": "IWUy",
	"./cover/baguette.jpg": "U4SU",
	"./cover/belts.jpg": "mDbw",
	"./cover/fashionaccessories.jpg": "IzJR",
	"./cover/fashionjewelry.jpg": "5tkO",
	"./cover/manminibags.jpg": "Go3T",
	"./cover/manslg.jpg": "2TqY",
	"./cover/peekaboo.jpg": "kbeO",
	"./cover/rules-icon.png": "QCYb",
	"./cover/sunglasses.jpg": "wOlw",
	"./cover/textiles.jpg": "pyg4",
	"./cover/watches.jpg": "zLMK",
	"./cover/womanminibags.jpg": "cYrS",
	"./cover/womanslg.jpg": "Lk7u",
	"./default-avatar.png": "PsX4",
	"./dior-产品logo.png": "DJIu",
	"./fa.jpg": "hDGt",
	"./filter-down-active.png": "ZF0N",
	"./filter-down.png": "hS8E",
	"./filter-up-active.png": "x4cK",
	"./filter-up.png": "6C8B",
	"./home-bg-mb.jpg": "JaG3",
	"./home-bg.jpg": "3b/Y",
	"./icon/add+.png": "B7CY",
	"./icon/add_no.png": "JrV/",
	"./icon/address.png": "rI9u",
	"./icon/cart.png": "1VRk",
	"./icon/delete.png": "ty0o",
	"./icon/eye.png": "l2uD",
	"./icon/left.png": "8AFt",
	"./icon/logo-2.png": "Ki7x",
	"./icon/logo-3.png": "hgqE",
	"./icon/mine.png": "GSkE",
	"./icon/nav-cart.png": "XjQC",
	"./icon/password.png": "IH9h",
	"./icon/search.png": "GY9m",
	"./icon/sell-out.png": "SVhp",
	"./icon/sellout.png": "113C",
	"./icon/user.png": "TlOy",
	"./icon/品牌归属.png": "WGBX",
	"./icon/售罄.png": "DiPl",
	"./icon/售罄_优惠券标签.png": "sGzY",
	"./icon/微信支付.png": "sB+o",
	"./icon/成功.png": "vu2G",
	"./icon/箭头.png": "ab/w",
	"./index-bg-mobile@2x.jpg": "Gr0E",
	"./index-bg.jpg": "bMg+",
	"./left.png": "xDWF",
	"./login-bg.jpg": "kDKx",
	"./logo-fendi.png": "z3xB",
	"./logo-mb.png": "PreA",
	"./logo.png": "7Otq",
	"./mobile/_订单.png": "LA4e",
	"./mobile/address.png": "JTUL",
	"./mobile/cart-cart.png": "Hss1",
	"./mobile/cart-mb-select.png": "YJsm",
	"./mobile/cart-mb.png": "w6j7",
	"./mobile/cart.png": "RZwC",
	"./mobile/cat-select.png": "XWY3",
	"./mobile/cat.png": "NmuN",
	"./mobile/cata.png": "xLV+",
	"./mobile/home-mb-select.png": "g7m3",
	"./mobile/home.png": "mQdu",
	"./mobile/left.png": "EnDv",
	"./mobile/menu.png": "2oj2",
	"./mobile/my-mb-select.png": "k+7V",
	"./mobile/my.png": "i9oP",
	"./mobile/outline-tag.png": "swUe",
	"./mobile/pagehome.png": "gwDK",
	"./mobile/password.png": "3Afq",
	"./mobile/profile.png": "zhT1",
	"./mobile/sallout.png": "3U2m",
	"./mobile/user.png": "fdLE",
	"./mobile/userlogin.png": "2emS",
	"./mobile/付款.png": "8A5f",
	"./mobile/快递 (1).png": "ejC9",
	"./my-icon.png": "RUOW",
	"./order.png": "x5oV",
	"./pc-bg.png": "5RU8",
	"./pc_banner.png": "MTEA",
	"./peekaboo1.jpg": "Tv0Q",
	"./popcart.png": "2aqk",
	"./price_high_to_low-active.png": "usni",
	"./price_high_to_low.png": "2zNY",
	"./price_low_to_high-active.png": "O51l",
	"./price_low_to_high.png": "LkII",
	"./profile-2.png": "i+my",
	"./profile.png": "65UA",
	"./result-mobile-2.png": "VDK9",
	"./result-mobile.png": "+MGD",
	"./rules-icon.png": "rnmA",
	"./rules-mobile.png": "gweS",
	"./rules.png": "OHHN",
	"./sc_learn_68x37.gif": "Oxxq",
	"./search-no.png": "hW8B",
	"./soldout.png": "kPyC",
	"./spec-selected.png": "4FWg",
	"./top.png": "Uw9C"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1